export const ShopContext = Object.freeze({
    PROFILE: 'PROFILE',
    CHECKOUT: 'Market'
});

//Todo use the orderType in ns-shop
export const OrderType = Object.freeze({
    PROFILE: 'PROFILE',
    ADR_MANAGE: 'ADR MANAGE',
    SINGLE_ORDER: 'SINGLE ORDER',
    ADR_CREATE: 'ADR CREATE',
    ADR_OVERRIDE: 'ADR OVERRIDE',
    SHIP_IMMEDIATE: 'SHIP IMMEDIATE'
});

export const TdcStringContext = Object.freeze({
    CHECKOUT: 'checkout'
});
